const onboardingService = require("../../../../services/onboard");
const FV = require('../../../components/form-validation/form-validation.script');
var donations = [];
const ngosService = require("../../../../services/ngos.js");
const donorsService = require("../../../../services/donors.js");
let debounceTime = 0;
let interval = null;
let searchInputValue = '';
window.ngos = [];

export async function load() {

    // add a click event to addItemBtn
    document
        .getElementById("addItemBtn")
        .addEventListener('click', (e) => {
            addItem()
        })

    // add event click to cadastrarNecessidades
    document.getElementsByName("cadastrarNecessidades")
        .forEach((selTipoEl) => {
            selTipoEl.addEventListener('click', (e) => {
                switchForm(selTipoEl.value)
            })
        })


    try {
        //add first form element
        addItem()
        switchForm("true")
        startForm(document.getElementById("etapa_4"))
        addSearchInputListeners(document.getElementById("search-ngo"));
        findNgos();
        activateNgofake();

        return true
    } catch (err) {
        return err
    }
}


async function switchForm(type) {

    const itemContainer = document.getElementById("itemsContainer")
    if (type == 'true') {

        itemContainer
            .classList.remove("disabled")

        Array.from(itemContainer
                .getElementsByTagName("textarea"))
            .forEach((el) => {
                el.disabled = false
            })

        Array.from(itemContainer
                .getElementsByTagName("input"))
            .forEach((el) => {
                el.disabled = false
            })
    } else {
        itemContainer
            .classList.add("disabled")


        Array.from(itemContainer
                .getElementsByTagName("textarea"))
            .forEach((el) => {
                el.disabled = true
            })

        Array.from(itemContainer
                .getElementsByTagName("input"))
            .forEach((el) => {
                el.disabled = true
            })
    }
}

function addItem() {

    const itemsContainer = document.getElementById("itemsContainer")

    const UUID = uuidv4()

    var item = `
  <donation-item id="${UUID}">
      <div class="label-float">
      <inputBox field="description_${UUID}" type="textarea" isRequired="true" inputType="textarea" friendlyName="Descrição">
            <textarea  id="description_${UUID}" name="description" cols="30" rows="10" placeholder="Escreva aqui o item que você pode doar"></textarea>

              <errorMessage>Este campo é obrigatório para prosseguir</errorMessage>
          </inputBox>
      </div>
      <div class="upload-fotos">
          <div class="drop-imgs">
            <inputBox field="image_${UUID}" type="image_${UUID}" isRequired="true" inputType="file" friendlyName="Imagem">
                <input type="file" accept="image/*" name="ongPictures" class="ongPictures" id="selectFile_${UUID}">

              <label for="ongPictures">
                  <img alt="Selecione uma imagem para seu item" src="./images/icons/cam.svg"> <placeholder>Selecione uma imagem para seu item
                    </placeholder>

                    <span class="delete-icon d-none">
                        <placeholder>Deletar item</placeholder> <img alt="Deletar item" src="./images/icons/trash-icon.svg">
                    </span>
                </label>
              <errorMessage>Este campo é obrigatório para prosseguir</errorMessage>
            </inputBox>
          </div>
          <div id="upload_list"></div>
      </div>
    </donation-item>`
    var donationObject = {
        id: UUID,
        description: "",
        image: null
    }
    donations.push(donationObject)
    itemsContainer.innerHTML += item;

    updateEventListener()
}

function updateEventListener() {
    Array.from(document.getElementsByTagName("donation-item"))
        .forEach((el, i) => {
            var UUID = el.getAttribute('id')
            var descriptionEL = el.getElementsByTagName('textarea')[0]
            var fileEl = el.getElementsByTagName('input')[0]
            var labelEl = el.getElementsByTagName('label')[0]

            descriptionEL.value = getDonationByID(UUID).description
            descriptionEL.addEventListener("keyup", (e) => updateFormValue(descriptionEL.value, UUID))
            fileEl.addEventListener("change", (e) => changeFile(e, UUID), true)
            var placeholderEl = el.getElementsByTagName('placeholder')[0]
            if (getDonationByID(UUID).image && getDonationByID(UUID).image.name) {

                fileEl.files = getDonationByID(UUID).originalFileList;

                placeholderEl.innerHTML = getDonationByID(UUID).image.name
                el.getElementsByTagName('img')[0].url = window.URL.createObjectURL(getDonationByID(UUID).image)

                var deleteIcon = el.querySelector('.delete-icon');

                if (deleteIcon.classList.contains('d-none')) {
                    deleteIcon.classList.remove('d-none');
                    deleteIcon.setAttribute('id', UUID);
                }

                deleteIcon.addEventListener('click', function(evt) {
                    const uniqueId = evt.target.getAttribute('id');
                    const index = donations.findIndex((value) => value.id == uniqueId);

                    if (index != -1) {

                        const documents = document.querySelectorAll(`donation-item`);

                        console.info(`Removed:  donation-item["id"="${uniqueId}"]`);

                        donations.splice(index, 1)

                        documents[index].remove();
                    }
                });

                if (!fileEl.classList.contains('has-file')) {
                    fileEl.classList.add('has-file');
                }

                if (!labelEl.classList.contains('has-file')) {
                    labelEl.classList.add('has-file');
                }
            }

        });
}

function updateFormValue(value, id) {
    var donation = donations.find((donation) => {
        return donation.id == id;
    })
    if (donation) {
        donation.description = value;
    }
}

function changeFile(e, id) {
    getDonationByID(id).originalFileList = e.srcElement.files;
    getDonationByID(id).image = e.srcElement.files[0];
    updateEventListener()
}


function getDonationByID(id) {
    var donation = donations.find((donation) => {
        return donation.id == id;
    })
    return donation
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function generateFormData() {

    var formData = new FormData();

    donations.forEach((donation, index) => {
        Object.keys(donation).forEach((key, i) => {
            if (key != 'originalFileList') {
                if (Object.keys(donation) == 'file') {
                    formData.append(`donation_item[${index}][${key}]`, donation[key], donation[key].name);
                } else {
                    formData.append(`donation_item[${index}][${key}]`, donation[key]);
                }
            }
        });

    });

    const searchInput = document.getElementById('search-ngo');
    const targetEntityId = searchInput.getAttribute('custom-value');

    // Adicionando ao form a ONG que foi selecionada
    formData.append('target_entity_id', targetEntityId);

    return formData
}

function startForm(formEl) {
    formEl
        .addEventListener('submit', function(evt) {
            evt.preventDefault()
            FV.clearErrosMessages(formEl)
            sendForm(formEl)
        })
}

async function sendForm(formEl) {
    const userID = formEl.getAttribute("userID")
    let registerType = formEl.getAttribute("registerType")

    if (registerType == "ong") {
        registerType = "ong_1";
    }

    const validSearchInput = validateCustomSearchInput();

    if (FV.thisFormIsValid(formEl) && validSearchInput) {
        const button = document.getElementById('sendButton');

        if (!button.classList.contains('loading')) {
            button.classList.add('loading');
        }

        const formData = generateFormData()

        try {
            const userObject = await donorsService.getProfile(userID);

            await onboardingService.donation(formData, userID)
            console.log("userObject",userObject)
            if (userObject && userObject.data && userObject.data.verified != 'no') {
                window.barba.go(`/cadastro/etapa_9?registerType=${registerType}`);
            } else {
                window.barba.go(`/cadastro/etapa_7/${userObject.data.hash}?registerType=${registerType}`);
            }

            if (button.classList.contains('loading')) {
                button.classList.remove('loading');
            }
        } catch (err) {
            if (button.classList.contains('loading')) {
                button.classList.remove('loading');
            }
            alert(err)
        }
    }

}

function validateCustomSearchInput() {
    const searchInput = document.getElementById('search-ngo');
    const errorMessage = document.getElementById('search-ngo-error');
    if (
        (!searchInput.value || searchInput.value == '' || searchInput.value == null) ||
        (!searchInput.getAttribute('custom-value') || searchInput.getAttribute('custom-value') == '' || !searchInput.getAttribute('custom-value') == null)
    ) {
        if (errorMessage.classList.contains('dp-none')) {
            errorMessage.classList.remove('dp-none');
        }
        errorMessage.innerHTML = 'Uma <strong>ONG</strong> deve ser selecionada.';
        return false
    }

    if (!errorMessage.classList.contains('dp-none')) {
        errorMessage.classList.add('dp-none');
    }
    errorMessage.textContent = '';
    return true
}

function addSearchInputListeners(input) {
    input.addEventListener('keyup', (evt) => {
        searchKeyup(evt);
    });

    input.addEventListener('focus', (evt) => {
        const options = document.querySelector('.ngo-options');

        if (options.classList.contains('dp-none')) {
            options.classList.remove('dp-none');
        }
    });

    input.addEventListener('blur', (evt) => {
        const options = document.querySelector('.ngo-options');

        if (!options.classList.contains('dp-none')) {
            setTimeout(() => options.classList.add('dp-none'), 150);
        }
    });
}

function searchKeyup(event) {
    debounceTime = 0;

    searchInputValue = event.target.value;

    if (interval != null) {
        return;
    }

    interval = setInterval((evt) => {
        debounceTime += 10;

        if (debounceTime == 200) {
            clearInterval(interval);
            findNgos();
            interval = null;
        }
    }, 10);
}

async function findNgos() {
    try {
        const input = document.getElementById("search-ngo");

        if (input.getAttribute('custom-value') && input.getAttribute('custom-value') != null && input.getAttribute('custom-value') != '') {
            input.removeAttribute('custom-value');
        }

        const query = {
            term: searchInputValue
        };
        ngos = await ngosService.findNgos(query);
        mountNgoList();

    } catch (error) {
        console.log(`function findNgos ERROR: `, error)
    }
}

function mountNGO(ngo, empty = false) {
    const liElement = document.createElement('li');
    liElement.className = 'option'
    if (empty) {
        liElement.textContent = 'Nenhum resultado encontrado.';
        liElement.setAttribute('value', '');
        liElement.setAttribute('keyTitle', '');
        liElement.setAttribute('disabled', '');
        return liElement;
    }

    liElement.textContent = ngo.ong_entities.name;
    liElement.setAttribute('value', ngo.ong_entities.entity_id);
    liElement.setAttribute('keyTitle', ngo.ong_entities.name);
    return liElement;
}

function addNGOClickListeners() {

    const ngoElements = document.querySelectorAll('.ngo-options .option');

    ngoElements.forEach(ngoEl => {
        ngoEl.addEventListener('click', activateNgo);
    });
}

function activateNgo(evt) {
    const input = document.getElementById("search-ngo");
    const id = evt.target.getAttribute('value');
    const value = evt.target.getAttribute('keyTitle');

    input.value = value;
    input.setAttribute('custom-value', id);


    const ngoElements = document.querySelectorAll('.ngo-options .option');

    ngoElements.forEach(element => {
        if (element.classList.contains('selected')) {
            if (input.getAttribute('custom-value') != element.getAttribute('value')) {
                element.classList.remove('selected');
            }
        } else {
            if (input.getAttribute('custom-value') == element.getAttribute('value')) {
                element.classList.add('selected');
            }
        }
    });

    validateCustomSearchInput();
}

function activateNgofake() {
    if (localStorage.getItem("queroDoar")) {
        const profile = JSON.parse(localStorage.getItem("queroDoar"))

        const input = document.getElementById("search-ngo");
        const id = profile.id;
        const value = profile.title;

        input.value = value;
        input.setAttribute('custom-value', id);


        const ngoElements = document.querySelectorAll('.ngo-options .option');

        ngoElements.forEach(element => {
            if (element.classList.contains('selected')) {
                if (input.getAttribute('custom-value') != element.getAttribute('value')) {
                    element.classList.remove('selected');
                }
            } else {
                if (input.getAttribute('custom-value') == element.getAttribute('value')) {
                    element.classList.add('selected');
                }
            }
        });

        validateCustomSearchInput();
    }

}

function mountNgoList() {
    const ngoListElement = document.querySelector('.ngo-options');
    ngoListElement.innerHTML = "";

    if (ngos.data.length > 0) {
        ngos.data.forEach(ngo => {
            const ngoHTML = mountNGO(ngo);
            ngoListElement.appendChild(ngoHTML);
        });
        addNGOClickListeners();
    } else {
        const ngoHTML = mountNGO(null, true);
        ngoListElement.appendChild(ngoHTML);
    }

}
